import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutotextService } from '../autotext.service';
import { ExamsService } from '../exams.service';
import { PregnancyService } from '../pregnancy.service';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';

@Component({
  selector: 'app-medicalhistory',
  templateUrl: './medicalhistory.component.html',
  styleUrls: ['./medicalhistory.component.scss'],
  standalone: false,
})
export class MedicalhistoryComponent implements OnInit {
  @Input('isWeightAss') isWeightAss;
  @Input('typeOfUser') typeOfUser;
  @Input('modality') modality;
  @Output() newItemEvent = new EventEmitter<boolean>();

  showHistory = false;
  lastMed: string;
  showAlert: boolean = false;

  atSTitleMedicalHistory = this.translate.instant('pregnancy.MedicalHistory.title');

  constructor(
    public ps: PregnancyService,
    public es: ExamsService,
    public atS: AutotextService,
    private translate: TranslateService,
    public loginService: LoginService,
    private patService: PatientsService
  ) {}

  // AR-24 change 3: AI medical-history summary from the patient's answered questionnaire.
  aiSummaryLoading = false;
  getAiSummary() {
    if (this.aiSummaryLoading) return;
    this.aiSummaryLoading = true;
    this.es.getAiSummary(this.es.ExamType, this.patService.getPat()?.PID).subscribe(
      (res: any) => {
        this.aiSummaryLoading = false;
        if (res && res.summary) {
          const control = this.ps.pregForm.get('Remarks');
          const existing = (control.value || '').toString().trim();
          const previous = (res.previousSummary || '').toString().trim();
          // Replace only our own previously-pasted AI block (exact match), so a
          // doctor's hand-typed notes are never overwritten; otherwise append.
          if (previous && existing === previous) {
            control.setValue(res.summary);
          } else {
            control.setValue(existing ? existing + '\n\n' + res.summary : res.summary);
          }
        } else if (res && res.reason) {
          alert('Could not generate a summary (' + res.reason + ').');
        }
      },
      () => {
        this.aiSummaryLoading = false;
      }
    );
  }

  ngOnInit() {
    if (this.es.ExamType == 'Fetal Echo') {
      this.showHistory = true;
      this.newItemEvent.emit(this.showHistory);
    }

    if (!this.es.isClosed) {
      this.es.getLastHistoryFromClosedPreg().subscribe(
        (data: any) => {
          if (data.history && Array.isArray(data.history)) {
            this.lastMed = data.history.map((record) => record.Remarks).join('\n');
          } else {
            this.lastMed = '';
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  setShowHistory() {
    this.showHistory = !this.showHistory;
    this.newItemEvent.emit(this.showHistory);
  }

  addLastMed() {
    const medicalHistoryValue = this.ps.pregForm.get('Remarks').value;
    if (medicalHistoryValue) {
      this.ps.pregForm.get('Remarks').setValue(medicalHistoryValue + '\n' + this.lastMed);
    } else {
      this.ps.pregForm.get('Remarks').setValue(this.lastMed);
    }
  }
}
